import { useAtom } from "@reatom/npm-react";
import clsx from "clsx";
import { Navigation } from "swiper/modules";
import { SwiperSlide, Swiper, SwiperRef } from "swiper/react";
import { currentServiceAtom } from "../../core/reatom/state/currentService/currentService";
import s from "./style.module.scss";
import "swiper/css";
import "swiper/css/navigation";
import { FullImageViewer } from "../FullImageViewer/FullImageViewer";
import { usePopout } from "../../core/reatom/state/popout/popout";
import { useState, useRef, useMemo } from "react";
import {
  Icon20ChevronLeftOutline,
  Icon20ChevronRightOutline,
} from "@vkontakte/icons";
import { isImageFile } from "@/core/helper/mime";

export const SwiperImages = () => {
  const [currentService] = useAtom(currentServiceAtom);
  const { set } = usePopout();
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef<SwiperRef | null>(null);

  const imageFiles = useMemo(() => {
    const preview = currentService?.preview_files?.[0];
    const otherImages =
      currentService?.files?.filter((file) => isImageFile(file.mime_type)) ??
      [];
    return preview ? [preview, ...otherImages] : otherImages;
  }, [currentService]);

  return (
    <div className={s.wrapper}>
      <Swiper
        modules={[Navigation]}
        navigation={{
          nextEl: `.swiper-button-next`,
          prevEl: `.swiper-button-prev`,
        }}
        spaceBetween={0}
        slidesPerView={1}
        className={s.swiper}
        ref={swiperRef}
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
      >
        {imageFiles.map((file) => (
          <SwiperSlide key={file.id} className={clsx(s.img)}>
            <button
              onClick={() =>
                set(<FullImageViewer url={file.url} name={file.name} />)
              }
            >
              <img src={file.url} alt={file.name} className={clsx(s.img)} />
            </button>
          </SwiperSlide>
        ))}
        <div className={clsx("swiper-button-next", s.buttons)}>
          <div className={s.left}>
            <Icon20ChevronRightOutline />
          </div>
        </div>
        <div className={clsx("swiper-button-prev", s.buttons)}>
          <div className={s.left}>
            <Icon20ChevronLeftOutline />
          </div>
        </div>
      </Swiper>

      <div className={s.customPagination}>
        {imageFiles.map((_, index) => {
          const isActive = index === activeIndex;
          const isLast = Math.abs(index - activeIndex) === 1;

          return (
            <div
              key={index}
              className={clsx(
                s.customBullet,
                isActive && s.customBulletActive,
                isLast && s.last
              )}
              onClick={() => swiperRef.current?.swiper.slideTo(index)}
            />
          );
        })}
      </div>
    </div>
  );
};
